import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EndpointsService {
  url = {
    city: ['/catalogue/city'],
    country: ['/catalogue/country'],
    institution: ['/catalogue/institution'],
    material: ['/catalogue/material'],
    pathology: ['/catalogue/pathology'],
    pathologiesCountry: ['/catalogue/pathology_country'],
    pathologiesCountryManifest: ['/catalogue/pathology_country_manifest'],
    pathologiesCountryStudy: ['/catalogue/pathology_country_study_types'],
    pathologySymptom: ['/catalogue/pathology_symptom'],
    pathologyTest: ['/catalogue/pathology_test'],
    studyTypesTestTypes: ['/catalogue/study_types_test_types'],
    state: ['/catalogue/state'],
    specialty: ['/catalogue/specialty'],
    studyTypeGather: ['/catalogue/study_type_gather'],
    symptom: ['/catalogue/symptom'],
    testType: ['/catalogue/test_type'],
    events: ['/event'],
    sampleInfo: ['/request/SampleInfo'],
    gatherInfo: ['/request/GatherInfo'],
    kitInfo: ['/request/kit-request']
  }
}
